<template>
  <div class="product-series">
    <el-row :gutter="24" class="statisticc" type="flex" v-if="top3 && top3.length > 0">
      <el-col :span="8" class="statisticc-left">
        <div class="statisticc-total card">
          <img src="@/assets/total_category.png" alt="" />
          <div class="info">
            <div class="info-title">{{ $t('Product.categoryTotal') }}</div>
            <b class="info-count">{{ categoryNum }}</b>
          </div>
        </div>
        <div class="statisticc-total card" style="margin-top: 24px;">
          <img src="@/assets/total_series.png" alt="" />
          <div class="info">
            <div class="info-title">{{ $t('Product.seriesTotal') }}</div>
            <b class="info-count">{{ totalNum }}</b>
          </div>
        </div>
      </el-col>
      <el-col :span="16" class="statisticc-right">
        <div class="statisticc-top3 card">
          <div :class="['second card', top3[1] ? '' : 'empty']">
            <template v-if="top3[1]">
              <div class="top3-title">{{ top3[1].name }}</div>
              <div class="top3-count">
                <b>{{ top3[1].productNum }}</b>
                <div class="top3-count-tip">{{ $t('Product.modelTotal') }}</div>
              </div>
            </template>
            <template v-else>
              <div class="empty-title">{{ $t('Product.tips1') }}</div>
              <p class="empty-desc">{{ $t('Product.tips2') }}</p>
            </template>
          </div>
          <div class="first card">
            <div class="top3-title">{{ top3[0].name }}</div>
            <div class="top3-count">
              <b>{{ top3[0].productNum }}</b>
              <div class="top3-count-tip">{{ $t('Product.modelTotal') }}</div>
            </div>
          </div>
          <div :class="['third card', top3[2] ? '' : 'empty']">
            <template v-if="top3[2]">
              <div class="top3-title">{{ top3[2].name }}</div>
              <div class="top3-count">
                <b>{{ top3[2].productNum }}</b>
                <div class="top3-count-tip">{{ $t('Product.modelTotal') }}</div>
              </div>
            </template>
            <template v-else>
              <div class="empty-title">{{ $t('Product.tips1') }}</div>
              <p class="empty-desc">{{ $t('Product.tips2') }}</p>
            </template>
          </div>
        </div>
      </el-col>
    </el-row>
    <CommonForm @search="formSearch" :form-json="formjson" :autoSearch="false" />
    <div class="table">
      <el-row :gutter="24" type="flex" style="flex-wrap: wrap;">
        <el-col :span="8" v-if="addRole">
          <div class="add-card" @click="add">
            <hl-button type="special" circle icon="el-icon-plus" needShadow @click="add">
            </hl-button>
            <p>{{ $t('Common.create') }}</p>
          </div>
        </el-col>
        <el-col :span="8" v-for="item in tableData" :key="item.id">
          <div class="card">
            <div class="series-icon">
              <img :src="getIcon(item.category)" />
            </div>
            <div class="series-desc">
              <div class="name">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                  <span class="nameText"> {{ item.name }}</span>
                </el-tooltip>
                <hl-tag
                  plain
                  :color="getColor(item.category)"
                  :borderColor="getColor(item.category)"
                  :backgroundColor="getColor(item.category)"
                  style="vertical-align: middle;"
                >
                  {{ item.categoryName }}
                </hl-tag>
              </div>
              <div class="code">{{ item.code }}</div>
              <div class="count">{{ item.productNum }}</div>
              <div class="hint">{{ $t('Product.modelTotal') }}</div>
            </div>
            <div v-if="operationRole" class="operation">
              <hl-button
                v-if="detailRole"
                type="special"
                circle
                onlyIcon
                :tip="$t('Common.detail')"
                @click="handleDetail(item)"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-detail_16"></use>
                </svg>
              </hl-button>
              <hl-button
                v-if="updateRole"
                type="special"
                circle
                onlyIcon
                :tip="$t('Common.edit')"
                @click="handleEdit(item)"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-edit_16"></use>
                </svg>
              </hl-button>
              <hl-button
                v-if="deleteRole"
                type="special"
                circle
                onlyIcon
                :tip="$t('Common.delete')"
                @click="handleDelete(item)"
              >
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-del_24"></use>
                </svg>
              </hl-button>
              <svg class="icon expand-icon" aria-hidden="true">
                <use xlink:href="#icon-more"></use>
              </svg>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <SeriesEdit :row="row" @refresh="refresh()" v-if="visible" :visible.sync="visible" />
    <SeriesDetail :row="row" v-if="detailVisible" :visible.sync="detailVisible" />
  </div>
</template>

<script>
import Tag from '@/components/CommonTable/Tag'
import SeriesEdit from './SeriesEdit'
import SeriesDetail from './SeriesDetail'

import formjson from './Model/Formjson.Index'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'
import { formatNumWithComma } from '@/utils/utils'

import { purpleColor, cyanblueColor, blueColor } from '@/style/var.scss'
import gatewayIcon from '@/assets/gateway.png'
import directDeviceIcon from '@/assets/direct_equipment.png'
import childDeviceIcon from '@/assets/sub_equipment.png'
import steamingOvenIcon from '@/assets/product_management_oven.png'
import refrigeratorIcon from '@/assets/product_management_refrigeration.png'
export default {
  mixins: [getRoleFromPath],
  components: {
    'hl-tag': Tag,
    SeriesEdit,
    SeriesDetail
  },
  data() {
    return {
      formjson,
      categoryNum: 0,
      totalNum: 0,
      top3: [],
      tableData: [],
      row: {},
      visible: false,
      detailVisible: false
    }
  },
  created() {
    this.getStatisticsData()
    this.formSearch()
  },

  computed: {
    /********* 权限 ***********/
    // this.role 计算属性通过mixins: [getRoleFromPath] 注入
    // 导出权限
    roleChildList() {
      return this.role.childList
    },
    // 新建
    addRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'add')
      return val ? val.isPermission == 'Y' : false
    },
    // 编辑
    updateRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'update')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除
    deleteRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'del')
      return val ? val.isPermission == 'Y' : false
    },
    // 详情
    detailRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'detail')
      return val ? val.isPermission == 'Y' : false
    },
    operationRole() {
      return this.updateRole || this.deleteRole || this.detailRole
    }
    /********* 权限 ***********/
  },
  filters: {
    formatNumWithComma
  },
  methods: {
    refresh() {
      this.formSearch()
      this.getStatisticsData()
    },
    formSearch(data) {
      const params = {
        ...data,
        pageNum: 1,
        pageSize: 9999
      }
      this.$ajax
        .get(this.$api.product.series_list, params)
        .then((res) => {
          this.tableData = res.data.list
        })
        .catch(() => {})
    },
    getStatisticsData() {
      this.$ajax
        .get(this.$api.product.series_statistics)
        .then((res) => {
          if (res.data) {
            this.categoryNum = res.data.categoryNum
            this.totalNum = res.data.totalNum
            this.top3 = res.data.top3
          }
        })
        .catch(() => {})
    },
    getColor(category) {
      switch (category) {
        case 'gateway': // 网关
          return purpleColor
        case 'direct': // 直连设备
          return blueColor
        case 'child': // 子设备
          return cyanblueColor
        case 'steamingOven': // 子设备
          return blueColor
        case 'refrigerator': // 子设备
          return cyanblueColor
      }
    },
    getIcon(category) {
      switch (category) {
        case 'gateway': // 网关
          return gatewayIcon
        case 'direct': // 直连设备
          return directDeviceIcon
        case 'child': // 子设备
          return childDeviceIcon
        case 'steamingOven': // 蒸烤箱
          return steamingOvenIcon
        case 'refrigerator': // 制冷设备
          return refrigeratorIcon
      }
    },
    add() {
      this.row = {}
      this.visible = true
    },
    handleDetail(row) {
      this.row = row
      this.detailVisible = true
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleDelete(row) {
      this.$confirm(`${this.$t('Common.operationTips')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.product.series_delete, params)
            .then(() => {
              this.$message.success(`${this.$t('Common.delSuccess')}`)
              this.refresh()
            })
            .catch(() => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.product-series {
  .card {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px -2px 20px 0px rgba(34, 42, 57, 0.05);
    border-radius: 16px;
  }
  .statisticc {
    margin-bottom: 32px;
  }
  .statisticc-total {
    padding: 16px 24px;
    display: flex;
    img {
      width: 48px;
      height: 48px;
      display: block;
      margin-right: 24px;
    }
    .info-title {
      font-size: 16px;
      color: #666666;
    }
    .info-count {
      font-family: Barlow-SemiBold;
      font-size: 48px;
      color: #333333;
      line-height: 48px;
      font-weight: 600;
    }
  }
  .statisticc-top3 {
    display: flex;
    justify-content: space-between;
    height: 100%;
    padding: 24px 32px;
    .card {
      padding: 32px 24px 24px;
      box-shadow: 0 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &.empty {
        justify-content: center;
      }
    }
    .card + .card {
      margin-left: 24px;
    }
    .top3-title {
      font-size: 18px;
      color: #333333;
      font-weight: 500;
    }
    .top3-count b {
      font-family: Barlow-SemiBold;
      font-size: 36px;
      color: #333333;
      font-weight: 600;
      margin-bottom: 5px;
    }
    .top3-count-tip {
      color: #666666;
    }
    .first {
      flex-basis: 22.2%;
      background: url('../../../assets/top_one_bg.jpg') no-repeat left center / cover;
      .top3-title,
      .top3-count > b {
        color: #ffffff;
      }
      .top3-count-tip {
        color: #bfe0ff;
      }
    }
    .second {
      flex-basis: 33.3%;
      background: url('../../../assets/top_two_bg.jpg') no-repeat left center / cover;
    }
    .third {
      flex-basis: 44.4%;
      background: url('../../../assets/top_three_bg.jpg') no-repeat left center / cover;
    }
    .empty-title {
      font-size: 18px;
      color: #799798;
      font-weight: 500;
    }
    .empty-desc {
      margin-top: 13px;
      color: #a7bdbd;
    }
  }
  .table {
    .el-col {
      padding-bottom: 24px;
    }
    .add-card {
      height: 100%;
      min-height: 193px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 2.5px dashed rgba(218, 223, 230, 1);
      border-radius: 16px;
      cursor: pointer;
      &:hover {
        background: rgba(255, 255, 255, 0.5);
      }
      p {
        margin-top: 8px;
        font-size: 16px;
        color: #333333;
        text-align: center;
      }
    }
    .card {
      position: relative;
      display: flex;
      &:hover {
        box-shadow: 0px 10px 32px 0px rgba(23, 38, 64, 0.12);
        .operation {
          .hl-button {
            visibility: visible;
          }
          .expand-icon {
            color: $--color-blue;
          }
        }
      }
      .series-icon {
        width: 80px;
        height: 80px;
        background: rgba(255, 255, 255, 0.2);
        margin-top: -20px;
        margin-left: -20px;
        margin-right: 4px;
        border-radius: 8px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .series-desc {
        .name {
          font-size: 18px;
          color: #333333;
          font-weight: 500;
          .nameText {
            display: block;
            width: 180px;
            white-space: nowrap;

            overflow: hidden;

            text-overflow: ellipsis;
          }
        }
        .code {
          margin-top: 8px;
          color: #999999;
          margin-bottom: 32px;
        }
        .count {
          font-family: Barlow-SemiBold;
          font-size: 48px;
          color: #333333;
          letter-spacing: 0;
          line-height: 48px;
          font-weight: 600;
          margin-bottom: 4px;
        }
        .hint {
          color: #666666;
        }
      }
    }
    .operation {
      position: absolute;
      right: 25px;
      bottom: 24px;
      color: #a1a5ad;
      font-size: 24px;
      cursor: pointer;
      .hl-button {
        visibility: hidden;
        font-size: 16px;
        padding: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
